import { Badge, Box } from "@mantine/core";

type EcosystemExploreTypeBadgeRowProps = {
  label: string;
  /** Render only the badge (parent supplies padding/layout). */
  embedded?: boolean;
};

/** Shared top badge row for expert/corridor cards in the discover carousel. */
export default function EcosystemExploreTypeBadgeRow({
  label,
  embedded = false,
}: EcosystemExploreTypeBadgeRowProps) {
  const badge = (
    <Badge size="sm" radius="sm" color="primary" variant="filled" w="fit-content">
      {label}
    </Badge>
  );

  if (embedded) return badge;

  return (
    <Box px="md" pt={10} pb={4} style={{ flexShrink: 0 }}>
      {badge}
    </Box>
  );
}
